var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.368,
    height: 31,
    viewBox: "0 0 29.368 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(-6 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M28.842,8.895V7.263A3.263,3.263,0,0,0,25.579,4H15.789a3.263,3.263,0,0,0-3.263,3.263V8.895H7.632a1.632,1.632,0,0,0,0,3.263H9.263V30.105A4.895,4.895,0,0,0,14.158,35H27.211a4.895,4.895,0,0,0,4.895-4.895V12.158h1.632a1.632,1.632,0,1,0,0-3.263ZM25.579,7.263H15.789V8.895h9.789Zm3.263,4.895H12.526V30.105a1.632,1.632,0,0,0,1.632,1.632H27.211a1.632,1.632,0,0,0,1.632-1.632Z",
    transform: "translate(-6 -4)",
    fill: "#cacaca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M18,18h3.263V31.053H18Z",
    transform: "translate(-8.211 -6.579)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M26,18h3.263V31.053H26Z",
    transform: "translate(-9.684 -6.579)",
    fill: "#cacaca"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.3a446baab9ed3cc2a50cc4054022a791.svg";
export { ForwardRef as ReactComponent };